import router from './router'
import { getToken } from '@/utils/auth' // 验权

const whiteList = ['/login', '/removal'] // 不重定向白名单

router.beforeEach((to, from, next) => {
  if (getToken()) {
    if (to.path === "/login") {
      next('/')
    } else {
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      //next()
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
    }
  }

})
